import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GradeSubjectService {

  constructor(private http: HttpClient) { }

  getAllGradeSubject() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgradesubjects`);
  }

  getGradeSubjectById(id:any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgradesubjects/${id}`);
  }
  addGradeSubject(username:string,abrivid: any, gradeid: any, subjectid: any, notes: string, active: string,orgid:any) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmgradesubjects/${username}`, { abrivid, gradeid, subjectid, notes,active,orgid });
  }

  updateGradeSubjectStatus(username:string,id: any,  active: string,notes:string) {

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmgradesubjectupdate/${username}/${id}`, {id,active ,notes});
  }


  // semesters APIS
  getAllsemesters() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsemesterabriv`);
  }

  getSemesterById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsemesterabriv/${id}`);
  }

  //Batches APIS
  getALLBatches() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgrade`);
  }
  getBatchById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgrade/${id}`);
  }

}
